import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { isValidUrl } from '@ui/lib/helpers/validationHelpers'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  url: Yup.string().test('is-url-valid', 'URL is not valid', isValidUrl).required('URL must be provided'),
  instanceId: Yup.string().required('Username / Instance ID is required'),
  accessPolicyToken: Yup.string().required('Access Policy Token is required'),
}).required()

export default function GrafanaCloud(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="OTLP Endpoint*"
          placeholder="https://otlp-gateway-prod-us-west-0.grafana.net/otlp"
          disabled={props.disableInputs}
          register={register}
          name="url"
          error={errors['url']?.message}
        />
        <TextInput
          label="Access Policy Token*"
          placeholder="abc123"
          disabled={props.disableInputs}
          register={register}
          name="accessPolicyToken"
          error={errors['accessPolicyToken']?.message}
        />
        <TextInput
          label="Username / Instance ID*"
          placeholder="130834"
          disabled={props.disableInputs}
          register={register}
          name="instanceId"
          error={errors['instanceId']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
